import { Appointment } from '@sc/data-access-models';

export class AppointmentsAddedAction {
  static readonly type = '[Appointments] Added';

  constructor(public appointments: Appointment[], public merge = true) {}
}

export class AppointmentsClearedAction {
  static readonly type = '[Appointments] Cleared';
}

export class AppointmentsRemoveAction {
  static readonly type = '[Appointments] Removed';

  constructor(public appointmentsToRemove: string[]) {}
}
